// src/App.js
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import './App.css'
import Xieyi from './xieyi/index';
import Xieyi2 from './xieyi2/index';
// 全局样式
import 'reset-css'
import './common/styles/frame.styl'
import './common/styles/index.scss'
import './common/styles/emojis.scss'
const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Xieyi" element={<Xieyi />} />
                <Route path="/Xieyi2" element={<Xieyi2 />} />
            </Routes>
        </Router>
    );
};

export default App;